// extracted by mini-css-extract-plugin
export default {"container":"ourClient_container__DnyVd","card":"ourClient_card__eN3-R","image":"ourClient_image__-v6ww","img":"ourClient_img__tZR-X","content":"ourClient_content__FOkgz"};